fx.ns("models", class Story extends fx.ModelArray {

    constructor(data, photos)
    {
        super(data);

        this._photos = photos;
    }

    get coverPhoto()
    {
        let photo;
        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).cover_image)
            {
                photo = this._photos.find({ temporaryId : this.getItemAt(i).cover_image});
                break;
            }
        }
        return photo;
    }

    get photos()
    {
        if (!this._storyPhotos || this._storyPhotos.length == 0)
        {
            this._storyPhotos = [];
            for (let i = 0; i < this.groups.length; i++)
            {
                let group = this.groups.getItemAt(i);
                this._storyPhotos.push(...group.photos);
            }
        }
        return this._storyPhotos;
    }

    get numPhotoPerPage()
    {
        if (this.groups.length < 7)
            return 2;
        else
        if (this.groups.length < 10)
            return 3;
        else
            return 4;
    }

   get eventDescription()
   {
        let event_type = "";
        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).event_type)
            {
                event_type = this.getItemAt(i).event_type;
                break;
            }
        }
        return event_type;
   }

   get groups()
   {
        if (!this._groups)
        {
            this._groups = [];
            for (let i = 0; i < this.length; i++)
            {
                if (this.getItemAt(i).label)
                    this._groups.push( {label : this.getItemAt(i).label, ids : this.getItemAt(i).photos} );
            }
            this._groups = this._addPhotos(this._groups);
        }
        return this._groups;
   }

   get numPhotos()
   {
        let numPhotos = 0;
        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).label)
            {
                numPhotos += this.getItemAt(i).length;
                break;
            }
        }
        return numPhotos;
   }

   // split groups according to numPhotoPerPage 
   get possibleGroups()
   {
        if (!this._possibleGroups)
        {
            this._possibleGroups = [];

            for (let i = 0; i < this.groups.length; i++)
            {
                let group = this.groups.getItemAt(i);

                let numPhotoPerPage = this._numberPhotoPerPage(group.photos);
                let numberPages = group.photos.length / numPhotoPerPage;

                for (let j = 0; j < Math.floor(numberPages); j++)
                {
                    let obj = {  photos : group.photos.slice(j *numPhotoPerPage, (j + 1) * numPhotoPerPage) };
                    if (j == 0)
                        obj.label =  group.label;

                    this._possibleGroups.push( obj);
                }
                
                if (numberPages - Math.floor(numberPages) > 0)
                {
                    let photos = group.photos.slice(Math.floor(numberPages) * numPhotoPerPage, group.photos.length);

                    if (photos.length == 1)
                        this._possibleGroups.last().photos.push(...photos);
                    else
                        this._possibleGroups.push( { photos : photos } );  
                }
            }
        }
        return this._possibleGroups;
   }

   _numberPhotoPerPage(photos)
   {
        if (photos.length <= 8)
            return photos.length;

        return 8;
   }

   get groupPages()
   {
        return this.groups;
   }

   _addPhotos(groups)
   {
        for (let i = 0; i < groups.length; i++)
        {
            let group = groups[i];
            group.photos = [];
            for (let j = 0; j < group.ids.length; j++)
            {
                let photo = this._photos.find({temporaryId : group.ids.getItemAt(j)})
                
                if (photo)
                {
                    photo.calculateRate();
                    group.photos.push( photo );
                }
            }
            group.photos = group.photos.sort((a,b) => b.rate - a.rate);        
        }
        return groups;
   }

});